import { render, staticRenderFns } from "./c-tab.vue?vue&type=template&id=ce6a5a1a&"
import script from "./c-tab.vue?vue&type=script&lang=js&"
export * from "./c-tab.vue?vue&type=script&lang=js&"
import style0 from "./c-tab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports